export const setSearchValue = (value) => {
    return {
        type: 'ISSUE_SET_SEARCH_VALUE',
        payload: {
            value,
        },
    };
};
export const setItems = (items) => {
    return {
        type: 'ISSUE_SET_ITEMS',
        payload: {
            items,
        },
    };
};
export const setTypeItems = (items) => {
    return {
        type: 'ISSUE_SET_TYPE_ITEMS',
        payload: {
            items,
        },
    };
};
export const setSelectedItem = (data) => {
    return {
        type: 'ISSUE_SET_SELECTED_ITEM',
        payload: {
            data,
        },
    };
};
export const setSortSelectedItem = (data) => {
    return {
        type: 'ISSUE_SET_SORT_SELECTED_ITEM',
        payload: {
            data,
        },
    };
};
export const addItem = (data) => {
    return {
        type: 'ISSUE_ADD_ITEM',
        payload: {
            data,
        },
    };
};
export const updateItem = (data) => {
    return {
        type: 'ISSUE_UPDATE_ITEM',
        payload: {
            data,
        },
    };
};
export const setTransportItem = (data) => {
    return {
        type: 'ISSUE_SET_TRANSPORT_ITEM',
        payload: {
            data,
        },
    };
};
